import moment from 'moment';
import { getUnassignedCPDateText } from '../../../constants/gridText';

const MonthKeyCreator = ({ value }) => {
    if (!value || value.length === 0) {
        return getUnassignedCPDateText();
    }

    const monthValue = moment(value).format('MMMM YY').toString();
    return monthValue;
};

export default MonthKeyCreator;
